import { store } from "@/store/store";
import Vue from "vue";

export const showToast = function(toastText, isSuccess) {
  isSuccess
    ? Vue.prototype.$snotify.success(toastText, {
        timeout: 4000,
        showProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true
      })
    : Vue.prototype.$snotify.error(toastText, {
        timeout: 4000,
        showProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true
      });
};

export const getCaption = function(key) {
  let captions = store.getters.captions;
  if (typeof captions == "undefined") {
    return null;
  }

  return captions.hasOwnProperty(key) ? captions[key] : key;
};

export const setStaticPageTitle = function(pages, url) {
  let currentPage = pages.filter(page => {
    return page.url == url;
  });
  let title = this.getCaption(currentPage[0].contents[0].title);
  this.$store.dispatch("setPageTitle", title);
};

export default {
  methods: {
    getCaption,
    showToast,
    setStaticPageTitle
  }
};
